<template>
  <!-- 编辑组合/创建组合 -->
  <a-modal
    :title="groupid ? $t('message[1928]') : $t('message[1927]')"
    :visible="visible"
    :centered="true"
    :mask-closable="false"
    :width="672"
    wrap-class-name="tv-group-modal"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <!-- 可拖动对屏幕进行排序，将按照设定的顺序播放屏幕 -->
    <p class="prompt-text">
      {{ $t('message[1935]') }}
    </p>
    <a-form
      ref="form"
      :form="form"
    >
      <!-- 组合名称 -->
      <a-form-item
        :label="$t('message[1936]')"
        class="name-input"
      >
        <div
          v-decorator="['name', {
            rules: [{ required: true, validator: validateRepeat }],
            initialValue: groupDetail.name
          }]"
        >
          <a-input
            v-model="groupDetail.name"
            maxlength="8"
            :placeholder="$t('message[751]')"
            @change="handleInput($event, 'name')"
          />
          <span
            v-if="groupDetail.name"
            class="num"
          >{{ groupDetail.name.length }}/8</span>
        </div>
      </a-form-item>
      <a-form-item
        :label="$t('message[1787]')"
        :required="true"
        :validate-status="validateStatus"
        :help="validateStatus === 'error' ? $t('message[855]') : ''"
      >
        <a-popover
          trigger="click"
          :visible="showPop"
          overlay-class-name="tv-group-pop"
          placement="right"
          @visibleChange="handleClickChange"
        >
          <div slot="content">
            <ul class="group-select">
              <li
                v-for="item in selectOptions"
                :key="item.id"
              >
                <a-checkbox
                  :checked="item.checked"
                  @change="handleChangeCheck($event, item)"
                >
                  {{ item.name }}
                </a-checkbox>
              </li>
            </ul>
            <div class="btns">
              <a-button
                @click="handleCancelPop"
              >
                {{ $t('message[896]') }}
              </a-button>
              <a-button
                type="primary"
                @click="handleConfirmGroup"
              >
                {{ $t('message[915]') }}
              </a-button>
            </div>
          </div>
          <a-button>
            {{ $t('message[1413]') }}
          </a-button>
        </a-popover>

        <ul class="dray-list">
          <draggable
            v-model="drayList"
            :options="{
              animation: 60,
              handle:'.dray-item'
            }"
            class="result scroll_bar_beautify_ff"
            @end="dragEndHandle"
          >
            <!-- <transition-group> -->
            <li
              v-for="(item, i) in drayList"
              :key="item.id"
            >
              <i class="iconfont iconicon-test72 dray-item" />
              <a-tag
                closable
                @close="handleDeleteTag(item, i)"
              >
                {{ item.name }}
              </a-tag>
            </li>
            <!-- </transition-group> -->
          </draggable>
        </ul>
      </a-form-item>
      <!-- 播放间隔 -->
      <a-form-item
        :label="$t('message[1937]')"
        class="playtime-input"
      >
        <div
          v-decorator="['playtime', {
            rules: [{
              required: true,
              message: $t('message[751]')
            }],
            initialValue: groupDetail.playtime
          }]"
        >
          <a-input-number
            v-model="groupDetail.playtime"
            :placeholder="$t('message[751]')"
            :formatter="value => formatterValue(value)"
            @change="handleChangeNumber"
          />
          <span
            v-if="!$isEnglish"
            class="txt"
          >{{ $t('message[639]') }}</span>
          <!-- 屏幕切换时间间隔 -->
          <span class="fs-gray m-l-8 fz-12">{{ $t('message[1938]') }}</span>
        </div>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { checkRepeat } from '@/services/configTv'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    groupid: {
      type: [Number, String],
      default: ''
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      showPop: false,
      selectOptions: [],
      drayList: [],
      validateStatus: ''
    }
  },
  computed: {
    ...mapState('config/tv', ['groupDetail', 'tvSelectOptions'])
  },
  watch: {
    async visible (val) {
      if (!val) return

      this.validateStatus = ''
      if (this.groupid) {
        let chain = await this.getMergeConfig({
          id: this.groupid
        })
        chain.onSuccess(() => {
          this.selectOptions = this.setSelectOptions()
          this.drayList = this.setDrayData()
        })
      } else {
        this.selectOptions = this.setSelectOptions()
        this.drayList = this.setDrayData()
      }
    }
  },
  created () {
    this.getTvSelect()
  },
  methods: {
    ...mapActions('config/tv', ['getMergeConfig', 'setMergeConfig', 'getTvSelect']),
    hide () {
      this.$emit('update:visible', false)

      this.groupDetail.data = []
      this.groupDetail.id = ''
      this.groupDetail.name = ''
      this.groupDetail.playtime = 1

      this.form.resetFields()
    },
    handleInput (e, name) {
      let val = e.target.value
      this.groupDetail[name] = val
    },
    handleChangeNumber (val) {
      if (!val || (val && Number(val) < 1)) {
        val = 1
      }
      this.groupDetail['playtime'] = val
    },
    formatterValue (value) {
      if (typeof value === 'string') {
        return `${value.replace(/\D/g, '')}`
      }
      return (value === '' || Number(value) < 1) ? 1 : value
    },
    async validateRepeat (rule, value = '', callback) {
      let fieldvalue = value.toString()

      if (fieldvalue.trim() === '') {
        const msg = this.$t('message[751]')
        callback(msg)
      } else {
        let res = await checkRepeat()
          .params({
            id: this.groupid,
            type: 2,
            name: fieldvalue
          })
          .config({ tip: false, warn: false })
          .fetch()

        const { payload = {} } = res && res.data
        const { isrepeat = 0 } = payload

        if (isrepeat === 1) {
          // 已存在同名组合
          const msg = this.$t('message[1939]')
          callback(msg)
        } else {
          callback()
        }
      }
    },
    setSelectOptions () {
      const { data = [] } = this.groupDetail
      return this.tvSelectOptions.map(item => {
        let obj = item
        this.$set(obj, 'checked', false)
        data.forEach(id => {
          if (id === item.id) {
            this.$set(obj, 'checked', true)
          }
        })
        return obj
      })
    },
    setDrayData () {
      const { data = [] } = this.groupDetail
      let arr = []
      data.forEach(id => {
        this.selectOptions.forEach(item => {
          if (id === item.id) {
            arr.push(item)
          }
        })
      })
      return arr
    },
    handleChangeCheck (e, item) {
      const checked = e.target.checked
      this.selectOptions.forEach(o => {
        if (o.id === item.id) {
          this.$set(o, 'checked', checked)
        }
      })
    },
    /**
     * 拖拽
     */
    dragEndHandle () {
      this.groupDetail.data = this.drayList.map(item => item.id)
    },
    handleDeleteTag (item) {
      this.selectOptions.forEach(o => {
        if (o.id === item.id) {
          this.$set(o, 'checked', false)
        }
      })
      const len = this.groupDetail.data.length
      for (let i = len - 1; i >= 0; i--) {
        const id = this.groupDetail.data[i]
        if (id === item.id) {
          this.groupDetail.data.splice(i, 1)
        }
      }
      this.drayList = this.setDrayData()
    },
    handleClickChange (visible) {
      this.showPop = visible
    },
    handleConfirmGroup () {
      this.groupDetail.data = []
      this.selectOptions.forEach(item => {
        if (item.checked) {
          this.groupDetail.data.push(item.id)
        }
      })
      this.showPop = false
      this.drayList = this.setDrayData()
      if (!this.drayList.length) {
        this.validateStatus = 'error'
      } else {
        this.validateStatus = ''
      }
    },
    handleCancelPop () {
      this.showPop = false
    },
    async handleOk (e) {
      e.preventDefault()
      let _this = this
      if (!this.drayList.length) {
        this.validateStatus = 'error'
      } else {
        this.validateStatus = ''
      }
      this.form.validateFields(async (err, values) => {
        // console.log(err, values)

        if (!err && _this.validateStatus === '') {
          _this.groupDetail.playtime = Number(_this.groupDetail.playtime)
          let chain = await _this.setMergeConfig(_this.groupDetail)
          chain.onSuccess(res => {
            _this.hide()
            this.$emit('successAfter')
          })
        }
      })
    },
    handleCancel () {
      this.hide()
    }
  }
}
</script>
<style scoped lang="scss">
.ant-form {
  padding: 24px 64px;
}
::v-deep .ant-form-item-label {
  float: left;
  width: 110px;
  padding-right: 16px;
  label {
    color: #666;
  }
}
::v-deep .ant-form-item-children {
  display: inline-block;
}
::v-deep .ant-form-item-control-wrapper {
  padding-left: 110px;
}
.name-input {
  .num {
    position: absolute;
    top: 0;
    right: 0;
    padding-right: 12px;
    color: #D6D6D6;
  }
}
.playtime-input {
  .ant-input-number {
    width: 120px;
    padding-right: 20px;
  }
  .txt {
    position: absolute;
    top: 0;
    left: 100px;
    color: #D6D6D6;
  }
}
.group-select::v-deep {
  padding: 12px 0;
  li {
    margin: 0 8px;
    padding: 4px 8px;
    line-height: 24px;
  }
  li:hover{
    background: #F4F7F9;
    border-radius: 4px;
  }
  .ant-checkbox-wrapper {
    margin-bottom: 0;
  }
}
.btns {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 12px 0;
  text-align: center;
  background-color: #fff;
  border-top: solid 1px #ebebeb;
  .ant-btn {
    &:last-child {
      margin-right: 0;
    }
  }
}
.dray-list {
  margin-top: 16px;
  li {
    margin-bottom: 9px;
  }
  .iconfont {
    margin-right: 8px;
    color: #D6D6D6;
    font-size: 18px;
    vertical-align: middle;
  }
  .ant-tag {
    height: auto;
    display: inline-block;
    padding: 4px 12px;
    font-size: 14px;
    background-color: #fff;
    .anticon-close {
      font-size: 12px;
      color: #D6D6D6;
    }
  }
}
</style>

<style lang="scss">
.tv-group-modal {
  .ant-modal-header {
    height: 56px;
    padding: 16px 21px;
  }
  .ant-modal-body {
    padding: 0;
  }
  .prompt-text {
    padding: 8px 24px;
    background-color: #E8F4FF;;
  }
}
.tv-group-pop {
  .ant-popover-inner {
    position: relative;
  }
  .ant-popover-inner-content {
    padding: 0 0 57px;
    min-width: 192px;
    max-height: 300px;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
